import { render } from "./Approvals.vue?vue&type=template&id=ebf9bed2&scoped=true"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"

import "./Approvals.vue?vue&type=style&index=0&id=ebf9bed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf9bed2"]])

export default __exports__